import { useNavigate } from 'react-router-dom';
import CompoundedLanding from '../../.shared/CompoundedLanding/CompoundedLanding';
import { trackPostHogEvent } from '../../../utils/posthogUtils';
import { startInterview } from '../../../utils/interviewFlow';
import heroPortrait from '../../../assets/semaglutide-hero-portrait.webp';
import vialImage from '../../../assets/semaglutide-vial.webp';

const HERO = {
    image: heroPortrait,
    imageAlt: 'Patient holding a tb2.health compounded semaglutide vial',
    eyebrow: 'GLP-1 Care',
    title: 'Clinician-Guided GLP-1 Care',
    sub: 'Compounded Semaglutide · Weight management support through personalized care',
    subSmall: 'Complete your intake from your phone in minutes. See pricing and subscription terms before you begin.',
    ctaLabel: 'Get Started',
};

const TABS = [
    {
        id: 'included',
        label: "What's included",
        body: 'Clinician evaluation, ongoing care, and — if prescribed — medication, supplies, and shipping. One subscription, no surprise add-ons. Price includes all doses.',
    },
    {
        id: 'shipping',
        label: 'How it ships',
        body: 'If prescribed, your medication is dispensed by a state-licensed pharmacy. Many compounded GLP-1s require refrigeration at 36–46°F (2–8°C); detailed handling instructions are included.',
    },
    {
        id: 'providers',
        label: 'Provider roles',
        body: 'Platform facilitates care. Clinicians evaluate and prescribe independently. Pharmacies dispense.',
    },
];

const LOCKUP = {
    image: vialImage,
    imageAlt: 'tb2.health compounded semaglutide injection vial',
    eyebrow: 'Compounded GLP-1 Care',
    accent: 'Semaglutide',
    sentences: [
        { text: 'Once-weekly compounded semaglutide, prescribed only when clinically appropriate.' },
        { text: 'A licensed clinician reviews every intake and guides dose adjustments over time.' },
        { text: 'Semaglutide is a GLP-1 receptor agonist — a class of prescription medication.' },
    ],
};

const SAFETY = {
    columns: [
        {
            title: 'Dosing & expectations',
            sub: 'Clinician-directed',
            paragraphs: ['Your clinician determines dosing and adjusts over time. If prescribed, dose adjustments are included within your program.'],
            strong: 'Response varies. No guaranteed outcomes.',
        },
        {
            title: 'Possible side effects',
            sub: 'Disclose all medications',
            list: ['Nausea', 'Vomiting', 'Diarrhea', 'Abdominal discomfort', 'Decreased appetite'],
        },
    ],
};

export default function SemaglutideLanding() {
    const navigate = useNavigate();

    const handleGetStarted = (selected) => {
        // Enroll before tracking, so trackExposure has registered the variant
        // on this person and the submit event below carries it.
        const flow = startInterview();

        trackPostHogEvent('landing_page_submitted', {
            selected,
            to_path: '/interview',
            interview_flow: flow.id
        });
        navigate(flow.entryPath);
    };

    return (
        <CompoundedLanding
            hero={HERO}
            onCtaClick={handleGetStarted}
            price={{ product: 'semaglutide', formulation: 'injectable' }}
            tabs={TABS}
            lockup={LOCKUP}
            showPatientStories
            safety={SAFETY}
        />
    );
}
